import { Router } from 'pjax';
import form from './form.js';
import index from './index.js';

Router.get('judging/score-set/:any', form);
Router.get('judging/score-set', index);
